/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'delivery': {
    width: 16,
    height: 16,
    viewBox: '0 0 32 21',
    data: '<path pid="0" d="M20 0a2 2 0 012 2v3h4.47a2 2 0 011.6.79L32 10.94V15a2 2 0 01-1.85 2H30a4 4 0 11-8 0H11a4 4 0 11-8 0H2a2 2 0 01-2-2V2C0 .9.9 0 2 0h18zM7 15a2 2 0 100 4 2 2 0 000-4zm19 0a2 2 0 100 4 2 2 0 000-4zm.47-8H22v8h.54l-.05.08a4 4 0 017.02 0l-.05-.08H30v-3.38L26.47 7zM20 2H2v13h1.54l-.03.05a4 4 0 016.87-.18l.08.13H20V2z"/>'
  }
})
